<template>
  <div class="table-group">
    <div
      v-for="row in rows || {}"
      :key="`${row.isCustomUserRow ? `${row.name}-${row.attributeSegment.name}` : row.name}`"
    >
      <div
        :id="row.name"
        class="grid-row striped-row"
        :class="`theme-${theme}`"
      >
        <component
          :is="columnComponentForGroup(row, column, i)"
          v-for="(column, i) in columnsForRow(row)"
          :key="`${row.name}-${column.name || i}`"
          v-bind="columnComponentProps(row, column)"
          :style="getColumnWidthStyle(column)"
          :class="`theme-${theme}`"
        />
      </div>

      <TableGroup
        v-if="
          !row.isCustomUserRow &&
          (addRowGroup === row.name ||
            (row.children &&
              row.children.length &&
              expandedGroups[row.name] &&
              expandedGroups[row.name].expanded))
        "
        v-bind="{
          ...$props,
          onAddRow: handleAddRowFromChild,
          groups: row.children.slice(
            0,
            row.endPage || expandedGroups[row.name]?.endPage
          ),
          level: level + 1
        }"
      />
      <div
        v-if="
          !row.isCustomUserRow &&
          expandedGroups[row.name] &&
          expandedGroups[row.name].expanded &&
          expandedGroups[row.name].hasMoreChildren
        "
        class="load-more-button-wrapper"
        :class="`level-${level}`"
      >
        <button
          class="btn btn-link btn-sm ms-4 fs-7 d-flex align-items-center"
          @click="() => onLoadMoreGroups({ group: row })"
        >
          <i class="bi bi-arrow-down-short pe-1 fs-5"></i>
          <span>
            {{
              $t('groupsComparison.loadMoreInGroup', { groupName: row.title })
            }}
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import PulsTableTitleCell from './cells/PulsTableTitleCell.vue'
import PulsTableTagCell from './cells/PulsTableTagCell.vue'
import PulsTableCategoryCell from './cells/PulsTableCategoryCell.vue'
import PulsTableSelectGroupCell from './cells/PulsTableSelectGroupCell.vue'
import PulsTableQuestionCell from './cells/PulsTableQuestionCell.vue'
import PulsTableEmptyCell from './cells/PulsTableEmptyCell.vue'
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue'
import PulsTableTrendCell from './cells/PulsTableTrendCell.vue'
import PulsTableRowActionCell from './cells/PulsTableRowActionCell.vue'
import PulsTableButtonCell from './cells/PulsTableButtonCell.vue'
import PulsMultiSelect from '@/components/shared/puls-multi-select/PulsMultiSelect.vue'

export default {
  name: 'TableGroup',
  components: {},
  props: {
    addRowGroup: {
      type: String,
      default: null
    },
    allGroups: {
      type: Array,
      default: () => []
    },
    attributes: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      required: true
    },
    expandedGroups: {
      type: Object,
      default: () => {}
    },
    groups: {
      type: Array,
      default: () => []
    },
    level: {
      type: Number,
      default: 0
    },
    loading: {
      type: Object,
      default: () => {}
    },
    onAddRow: {
      type: Function,
      required: true
    },
    onCellClick: {
      type: Function,
      required: true
    },
    onExpandGroup: {
      type: Function,
      required: true
    },
    onLoadMoreGroups: {
      type: Function,
      required: true
    },
    onSelectAddRowGroup: {
      type: Function,
      required: true
    },
    onSelectGroup: {
      type: Function,
      required: true
    },
    onRemoveRow: {
      type: Function,
      required: true
    },
    organizationGroup: {
      type: Object,
      default: () => {}
    },
    surveyDetails: {
      type: Object,
      default: () => {}
    },
    surveyName: {
      type: String,
      required: true
    },
    surveyResults: {
      type: Object,
      default: () => {}
    },
    selectedAttributeSegment: {
      type: Object,
      default: () => {}
    },
    shouldShowTrend: {
      type: Boolean,
      default: false
    },
    tableConfig: {
      type: Object,
      required: true
    },
    tagSettings: {
      type: Array,
      default: () => []
    },
    theme: {
      type: String,
      default: 'default'
    },
    // updateSliderHeight: {
    //   type: Function,
    //   default: () => null
    // },
    userAddedRowsForSurvey: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      addRowSelections: {
        group: null,
        attributeSegment: this.attributes[0]
      }
    }
  },
  computed: {
    rows() {
      const groupsCopy = JSON.parse(JSON.stringify(this.groups))
      return groupsCopy.reduce((res, g) => {
        const group = { ...g }
        let extraRowsForGroupCount = 0
        if (!group.isCustomUserRow) {
          const userAddedRowsUnderGroup = this.userAddedRowsForSurvey?.filter(
            (row) => row.parentGroup === g.name
          )
          if (userAddedRowsUnderGroup?.length) {
            const userAddedRowsWithInfo = userAddedRowsUnderGroup.map(
              (userRow) => {
                const foundGroup = this.groups.find(
                  (g) => g.name === userRow.groupName
                )
                const foundGroupTitle = foundGroup
                  ? this.$tr(foundGroup.messages, 'title')
                  : userRow.groupName
                const attributeSegmentTitle = `${userRow.attributeSegment.attributeTitle} - ${userRow.attributeSegment.segmentTitle}`
                const title =
                  userRow.attributeSegment.name === 'all'
                    ? `${userRow.attributeSegment.title}: ${foundGroupTitle}`
                    : `${attributeSegmentTitle}: ${foundGroupTitle}`
                return {
                  // name: g.name,
                  name: userRow.groupName,
                  title,
                  attributeSegment: userRow.attributeSegment,
                  attributeSegmentKey: userRow.attributeSegment.name,
                  parentGroup: userRow.parentGroup,
                  isCustomUserRow: true
                }
              }
            )
            extraRowsForGroupCount += userAddedRowsWithInfo.length
            group.children = userAddedRowsWithInfo.concat(group.children)
          }
          if (this.addRowGroup === group.name) {
            group.children.unshift({
              group: {
                ...group,
                children: group.children.map((c) => ({ name: c.name }))
              },
              name: 'add-new-row'
            })
            extraRowsForGroupCount += 1
            // res.push({
            //   group: g,
            //   name: 'add-new-row'
            // })
          }
          // res.push(...userAddedRowsForGroup)
        }
        // if (this.expandedGroups[group.name]?.expanded) {
        // }
        group.endPage =
          (this.expandedGroups[group.name]?.endPage || 0) +
          extraRowsForGroupCount
        res.push(group)
        return res
      }, [])
    },
    allowedAttributesForSelectedGroup() {
      const attributesWithoutDisabled = this.attributes.map((a) => ({
        ...a,
        class: `level-${a.level}`,
        $isDisabled: false
      }))
      return attributesWithoutDisabled.filter((a) => {
        const alreadyAddedSegmentsForSelectedGroup = this.userAddedRowsForSurvey
          // this.addRowSelections.group
          ?.filter(
            (row) => row.groupName === this.addRowGroup
            // row.attributeSegment.attributeName === a.name
          )
          .map((r) => r.attributeSegment)

        const allSegmentsOfThisAttribute = this.attributes.filter(
          (child) => child.level === 1 && child.attributeName === a.name
        )

        const attributeIsHeader = a.level === 0
        const allSegmentsInAttributeAreAdded = allSegmentsOfThisAttribute.every(
          (segment) =>
            alreadyAddedSegmentsForSelectedGroup?.find(
              (addedSegment) => addedSegment.name === segment.name
            )
        )

        if (
          attributeIsHeader &&
          alreadyAddedSegmentsForSelectedGroup?.length > 1 &&
          allSegmentsInAttributeAreAdded
        ) {
          // if all segments of this attribute are already added, don't show the attribute header
          return false
        } else {
          const segmentIsAdded = !alreadyAddedSegmentsForSelectedGroup?.find(
            (addedSegment) => {
              return (
                (addedSegment.name === 'all' && a.name === 'all') ||
                (addedSegment.attributeName === a.attributeName &&
                  addedSegment.segmentName === a.segmentName)
              )
            }
          )
          return attributeIsHeader || segmentIsAdded
        }
      })
    }
  },
  methods: {
    columnsForRow(row) {
      if (row.name === 'add-new-row') {
        const res = [
          // {
          //   name: 'group-selector',
          //   template: 'title'
          // }
        ]
        if (this.attributes?.length) {
          res.push({
            name: 'attribute-segment-selector',
            template: 'attribute-segment-selector'
          })
        }
        res.push({
          name: 'button',
          template: 'button',
          variant: 'secondary',
          text: this.$t('general.cancel'),
          onClick: this.cancelAddRow
        })
        res.push({
          name: 'button',
          template: 'button',
          variant: 'primary',
          text: this.$t('general.add'),
          icon: 'bi-plus',
          onClick: this.addRowConfirm
        })
        return res
      } else {
        return this.columns
      }
    },
    // Always show group title. Show loading spinner after group title. Only show rest if group is not loading
    columnComponentForGroup(group, column, i) {
      if (column.template === 'title') {
        return PulsTableTitleCell
      }
      if (
        this.loading[group.name] &&
        ((group.attributeSegment?.name &&
          this.loading[group.name]?.includes(group.attributeSegment?.name)) ||
          (!group.attributeSegment?.name &&
            this.loading[group.name]?.includes('all')))
      ) {
        // replaces the participation column with a loading spinner when group is loading
        if (i === 0) {
          return PulsTableEmptyCell
        }
        if (i === 1) {
          return PulsTableSelectGroupCell
        }
        if (i === 3) {
          return LoadingSpinner
        }
      } else {
        if (column.template === 'button') {
          return PulsTableButtonCell
        } else if (
          column.template === 'group-selector' ||
          column.template === 'attribute-segment-selector'
        ) {
          return PulsMultiSelect
        } else if (
          column.name === 'participation' ||
          column.name === 'harassment'
        ) {
          return PulsTableTagCell
        } else if (
          this.shouldShowTrend &&
          (column.template === 'tags' ||
            column.template === 'categories' ||
            column.template === 'questions')
        ) {
          return PulsTableTrendCell
        } else if (column.template === 'tags') {
          return PulsTableTagCell
        } else if (column.template === 'categories') {
          return PulsTableCategoryCell
        } else if (column.template === 'questions') {
          return PulsTableQuestionCell
        } else if (column.template === 'add-row') {
          return PulsTableRowActionCell
        } else if (column.template === 'select-group') {
          return PulsTableSelectGroupCell
        } else if (column.template === 'remove-row' && group.isCustomUserRow) {
          return PulsTableRowActionCell
        } else {
          return PulsTableEmptyCell
        }
      }
    },
    columnComponentProps(row, column) {
      if (column.name === 'group-selector') {
        return {
          group: row.group,
          template: column.template,
          name: column.name,
          // create one extra level of padding because the added row would be a child
          level: this.level + 1
        }
      }
      // if (column.template === 'group-selector') {
      //   return {
      //     classes: `me-2 my-2 level-${this.level}`,
      //     variant: 'small',
      //     options: this.allGroups,
      //     selectedOption: row.group,
      //     onSelectOption: this.onSelectGroupToAdd
      //   }
      // }
      if (column.template === 'attribute-segment-selector') {
        return {
          classes: 'ms-2 me-2 my-2',
          variant: 'small',
          options: this.allowedAttributesForSelectedGroup,
          selectedOption: this.attributes[0],
          onSelectOption: this.onSelectSegmentToAdd
        }
      }
      if (column.template === 'button') {
        return {
          icon: column.icon,
          text: column.text,
          onClick: column.onClick,
          group: row.group,
          variant: column.variant || 'secondary'
        }
      }
      const attributeSegmentForRow =
        row.attributeSegment?.name || this.selectedAttributeSegment.name
      const attributeSegmentPath =
        attributeSegmentForRow !== 'all'
          ? `${attributeSegmentForRow.split('-')[0]}.${attributeSegmentForRow.split('-')[1]}`
          : 'all'
      const resultPath = `${row.name}.${attributeSegmentPath}.${column.template}.${column.name}.value`
      let value = this.$get(this.surveyResults, resultPath)

      let result = ''
      if (value >= 7) {
        result = 'high'
      } else if (value >= 4) {
        result = 'medium'
      } else if (value < 4) {
        result = 'low'
      }

      const props = {
        group: row,
        value,
        result,
        template: column.template,
        name: column.name
      }
      // props for PulsTableTrendCell
      if (this.shouldShowTrend) {
        const basePathForResults = `${row.name}.${attributeSegmentPath}.trend${column.template.charAt(0).toUpperCase() + column.template.slice(1)}.${column.name}`
        const regressionValuesResultPath = `${basePathForResults}.regressionValues`
        const regressionValues = this.$get(
          this.surveyResults,
          regressionValuesResultPath
        )
        props.regressionValues = regressionValues
        const averagesResultPath = `${basePathForResults}.averages`
        const averages = this.$get(this.surveyResults, averagesResultPath)
        props.averages = averages
        props.title = column.header
      }
      if (column.name === 'participation') {
        const participationTagPath = `${row.name}.${attributeSegmentPath}.${column.template}.${column.name}`
        const participationTag = this.$get(
          this.surveyResults,
          participationTagPath
        )
        const selectedAttributeSegmentNameForRow =
          row.attributeSegment?.name || this.selectedAttributeSegment.name
        props.description = this.numberOfUsersThatHaveRespondedText({
          group: row,
          participation: participationTag,
          selectedAttributeSegmentName: selectedAttributeSegmentNameForRow
        })
        if (selectedAttributeSegmentNameForRow === 'all') {
          props.value = this.$localeNumber(props.value * 10, 0) + '%'
        } else {
          props.value = participationTag?.amount_10 || ''
        }
      }
      if (column.name === 'harassment') {
        if (!!value) {
          props.description = this.$t('groupsComparison.violationsIn', {
            groupName: row.title || this.$tr(row.messages, 'title')
          })
        }
      }
      if (column.name === 'enps') {
        const npsResultPath = `${row.name}.${attributeSegmentPath}.${column.template}.${column.name}.npsData`
        const npsData = this.$get(this.surveyResults, npsResultPath)
        props.npsData = npsData
        const enpsSummary = npsData?.summary
        if (enpsSummary) {
          if (enpsSummary === 'broken' || enpsSummary === 'bad') {
            props.result = 'low'
          } else if (enpsSummary === 'neutral') {
            props.result = 'medium'
          } else {
            props.result = 'high'
          }
        } else {
          props.result = null
        }
      }

      if (column.template === 'title') {
        props.addRowGroup = this.addRowGroup
        props.onExpandGroup = this.onExpandGroup
        props.level = this.level
        props.isExpandedGroup = this.expandedGroups[row.name]?.expanded
        props.isSegment = Boolean(
          row.attributeSegment?.name && row.attributeSegment?.name !== 'all'
        )
      }
      if (column.template === 'select-group') {
        props.onSelectGroup = this.onSelectGroup
      }
      if (column.template === 'add-row') {
        props.addRowGroup = this.addRowGroup
        props.onClickActionCell = this.handleClickAddRow
      }
      if (column.template === 'remove-row') {
        props.onClickActionCell = this.onRemoveRow
      }
      if (column.template === 'tags') {
        props.zeroToHundred = this.tagSettings?.find(
          (s) => s.tagName === column.name
        )?.zeroToHundred
        if (props.zeroToHundred) {
          props.value = props.value = this.$localeNumber(props.value * 10, 0)
        }
      }

      if (
        column.template === 'questions' &&
        Object.keys(props).includes('value') &&
        props.value !== undefined
      ) {
        const questionResultPath = `${row.name}.${attributeSegmentPath}.${column.template}.${column.name}`
        const q = this.$get(this.surveyResults, questionResultPath)
        if (q.type === 'yesOrNo') {
          props.percentageString = `${this.$localeNumber(props.value * 10, 0)}%`
          if (q.yesIsBad) {
            if (value >= 7) {
              props.result = 'low'
            } else if (value >= 4) {
              props.result = 'medium'
            } else if (value < 4) {
              props.result = 'high'
            }
            if (q.isHarassmentQuestion) {
              props.result = props.value > 0 ? 'low' : 'high'
              if (props.value > 0) {
                props.description = this.$t('groupsComparison.violationsIn', {
                  groupName: row.title || this.$tr(row.messages, 'title')
                })
              }
            }
          }
        }
      }

      if (
        column.template === 'categories' ||
        column.template === 'tags' ||
        column.template === 'questions'
      ) {
        props.onCellClick = (type, name) => {
          const attributeSegmentForRow =
            row.attributeSegment?.name || this.selectedAttributeSegment.name
          this.onCellClick({
            statItemType: type,
            statItemName: name,
            surveyName: this.surveyName,
            group: row,
            segmentName: attributeSegmentForRow
          })
        }
      }
      return props
    },
    getColumnWidthStyle(column) {
      let width = undefined
      if (
        this.tableConfig.columnWidth.name &&
        this.tableConfig.columnWidth.name[column.name] !== undefined
      ) {
        width = this.tableConfig.columnWidth.name[column.name]
      } else if (
        this.tableConfig.columnWidth.template &&
        this.tableConfig.columnWidth.template[column.template] !== undefined
      ) {
        width = this.tableConfig.columnWidth.template[column.template]
      }

      let marginRight = 0
      if (this.tableConfig.columnWidth.margin[column.template]) {
        const marginColNames = this.columns.reduce((acc, col) => {
          if (col.template === column.template) {
            acc.push(col.name)
          }
          return acc
        }, [])
        if (column.name === marginColNames[marginColNames.length - 1]) {
          marginRight = this.tableConfig.columnWidth.margin[column.template]
        }
      }
      return width !== undefined
        ? {
            maxWidth: width + 'px',
            minWidth: width + 'px',
            overflow: width === 0 ? 'hidden' : 'visible',
            borderWidth: width === 0 ? '0px' : '1px',
            margin: width === 0 ? '0px' : '2px',
            marginRight: marginRight === 0 ? '0px' : marginRight + 'px'
          }
        : {}
    },
    cancelAddRow() {
      this.onSelectAddRowGroup(null)
    },
    handleClickAddRow(group) {
      this.addRowSelections.group = group.name
      if (group.name === this.addRowGroup) {
        this.cancelAddRow()
      } else {
        this.onSelectAddRowGroup(group.name)
      }
      // this.updateSliderHeight()
    },
    onSelectGroupToAdd(groupOption) {
      this.addRowSelections.group = groupOption.name
    },
    onSelectSegmentToAdd(segmentOption) {
      this.addRowSelections.attributeSegment = segmentOption
    },
    handleAddRowFromChild({ group, surveyName, attributeSegment }) {
      this.onAddRow({
        group,
        surveyName,
        attributeSegment:
          attributeSegment || this.addRowSelections.attributeSegment
      })
      this.onSelectAddRowGroup(null)
      this.addRowSelections = {
        group: null,
        attributeSegment: this.attributes[0]
      }
    },
    addRowConfirm(group) {
      this.onAddRow({
        group,
        surveyName: this.surveyName,
        attributeSegment: this.addRowSelections.attributeSegment
      })
      this.onSelectAddRowGroup(null)
      this.addRowSelections = {
        group: null,
        attributeSegment: this.attributes[0]
      }
    },
    participationSettingsForGroup(group) {
      if (group.name === this.organizationGroup.name) {
        return this.surveyDetails.resultViews.participation || {}
      } else if (group.config?.results?.participation) {
        return group.config.results.participation
      } else {
        return this.surveyDetails.resultViews.participation || {}
      }
    },
    numberOfUsersThatHaveRespondedText({
      group,
      participation,
      selectedAttributeSegmentName
    }) {
      if (participation) {
        if (participation.numberOfResponses > 0) {
          const p = this.participationSettingsForGroup(group)
          const invitedText =
            !p.hideResponded && selectedAttributeSegmentName === 'all'
              ? `/${participation.numberOfResponses}`
              : ''

          const responders = participation.amount_10 || 0

          const percentageText =
            !p.hidePercentage && p.hideInvited
              ? ` (${Math.round((responders / participation.numberOfResponses) * 100)}%)`
              : ''

          const respondedText = !p.hideInvited
            ? `${responders}${invitedText} ` +
              this.$t('groupsComparison.noResultsResponded')
            : ''
          return `${respondedText}${percentageText}`
        }
        return this.$t('groupsComparison.noone')
      }
    }
  }
}
</script>

<style lang="scss">
@use '../../../assets/scss/_brand.scss' as *;
$title-width: 230px;

.grid-row {
  align-items: center;
  display: flex;
}
// .table-header-cell-title {
//   &.title {
//     max-width: $title-width;
//     min-width: $title-width;
//   }
// }
.puls-multi-selector {
  @for $i from 1 through 10 {
    // You can adjust the range based on the number of levels you have
    &.level-#{$i} {
      padding-left: #{($i + 1) * 24}px;
    }
  }
}
.load-more-button-wrapper {
  background-color: var(--kt-table-active-bg);
  border-bottom: 1px solid var(--kt-table-border-color);
  @for $i from 0 through 10 {
    // You can adjust the range based on the number of levels you have
    &.level-#{$i} {
      padding-left: #{($i + 1) * 24}px;
    }
  }
}
.grid-row {
  .table-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 25px;
    border: 1px solid var(--kt-table-border-color);
    border-radius: var(--bs-card-inner-border-radius);
    margin: 2px;
    font-size: 0.95rem;
    color: var(--kt-black);
    // TODO: can we make a nice looking transition when click inspect category?
    // transition:
    //   border-width 0.2s ease,
    //   margin 0.2s ease,
    //   max-width 0.2s ease,
    //   min-width 0.2s ease;
    &.table-cell-empty {
      border: none;
    }
    &.action-cell.remove-row {
      border: none;
    }
    &.action-cell.add-row {
      transition: opacity 0.1s ease;
      min-width: 22px;
      opacity: 0;
    }

    &.title {
      color: var(--kt-gray-900);
      justify-content: start;
      border: none !important;
      @for $i from 1 through 10 {
        // You can adjust the range based on the number of levels you have
        &.level-#{$i} {
          padding-left: #{$i * 24}px;
        }
      }
    }
    &.table-trend-cell,
    &.participation,
    &.harassment {
      color: var(--kt-gray-900);
      border: none !important;
    }
    &.enps {
      &:hover {
        background-color: var(--kt-gray-200);
      }
    }
    &.no-value {
      background-color: var(--kt-gray-100);
      color: var(--kt-gray-700);
    }
    &.low {
      background-color: $brand-red;
      &:hover {
        background-color: rgb(221, 89, 89) !important;
      }
    }
    &.medium {
      background-color: $brand-yellow;
      &:hover {
        background-color: #e3c722 !important;
      }
    }
    &.high {
      background-color: $brand-green;
      &:hover {
        background-color: rgb(131, 196, 96) !important;
      }
    }
  }
  &.theme-monochrome {
    .table-cell {
      color: var(--kt-dark);
      &.low,
      &.medium,
      &.high {
        background-color: transparent !important;
        &:hover {
          background-color: rgba(0, 0, 0, 0.1) !important;
        }
      }
    }
  }
  &:hover {
    .action-cell.add-row {
      opacity: 1;
    }
  }
}
.striped-row:nth-child(odd) {
  border-bottom: 1px solid var(--kt-table-border-color);
}
.striped-row:nth-child(odd) {
  background: var(--kt-table-bg);
}
.striped-row:nth-child(even) {
  background: var(--kt-table-striped-bg);
}
</style>
